import React, { useState, useContext } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Firebase } from '../../firebase/config';
import { ToastContext } from '../../contextStore/ToastContext';
import { validateEmail } from '../../utils/validation';
import ButtonSpinner from '../UI/ButtonSpinner';
import './ForgotPassword.css';

function ForgotPassword() {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');
  const { addToast } = useContext(ToastContext);

  const handleSubmit = (e) => {
    e.preventDefault();
    const err = validateEmail(email);
    if (err) {
      setError(err);
      return;
    }
    setError('');
    setLoading(true);
    Firebase.auth()
      .sendPasswordResetEmail(email.trim())
      .then(() => {
        setSent(true);
        addToast(t('auth.resetEmailSent'), 'success');
      })
      .catch((err) => {
        setLoading(false);
        setError(err.message || t('auth.resetEmailFailed'));
      });
  };

  if (sent) {
    return (
      <div className="forgotPasswordWrap">
        <div className="forgotPasswordCard">
          <h2>{t('auth.checkYourEmail')}</h2>
          <p>
            {t('auth.resetEmailSentTo')} <strong>{email}</strong>
          </p>
          <Link to="/login">{t('auth.backToLogin')}</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="forgotPasswordWrap">
      <div className="forgotPasswordCard">
        <h2>{t('auth.forgotPasswordTitle')}</h2>
        <p>
          {t('auth.forgotPasswordDesc')}
        </p>
        <form onSubmit={handleSubmit}>
          <div className="forgotFormGroup">
            <label htmlFor="forgot-email">{t('auth.email')}</label>
            <input
              id="forgot-email"
              type="email"
              placeholder={t('auth.emailPlaceholder')}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              disabled={loading}
            />
            {error && <span className="formError">{error}</span>}
          </div>
          <button type="submit" disabled={loading}>
            {loading && <ButtonSpinner />}{t('auth.sendResetLink')}
          </button>
        </form>
        <Link to="/login">{t('auth.backToLogin')}</Link>
      </div>
    </div>
  );
}

export default ForgotPassword;
